"use client";

import setInGameCurrencyAction from "@casino/actions/Games/setInGameCurrency";
import getPreferredGameCurrency from "@casino/actions/getPreferredGameCurrency";
import useCashierCurrencyChange from "@casino/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCashierCurrencyChange";
import useCurrencyChangeListener from "@casino/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCurrencyChangeListener";
import { useGamePageData } from "@casino/ui/Games/hooks";
import * as React from "react";

const DEFAULT_OPTION_NAME = "Default";

type Option = {
  name: string;
  value?: string;
};

const useInGameCurrencySelect = () => {
  const { inGameCurrency, setInGameCurrency, inGameCurrencyList } =
    useGamePageData();
  const [isPending, setPending] = React.useState(false);

  const syncPreferredCurrency = async () => {
    const preferredCurrency = await getPreferredGameCurrency();
    const validCurrency =
      preferredCurrency && inGameCurrencyList.includes(preferredCurrency)
        ? preferredCurrency
        : undefined;
    setInGameCurrency(validCurrency);
  };

  useCashierCurrencyChange({ onChange: syncPreferredCurrency });
  useCurrencyChangeListener({ onChange: syncPreferredCurrency });

  const options: Option[] = [
    ...inGameCurrencyList.map((currency) => ({
      name: currency,
      value: currency,
    })),
    { name: DEFAULT_OPTION_NAME },
  ];

  const handleSelect = async (currency?: string) => {
    if (currency === inGameCurrency) return;

    setPending(true);
    const { errors } = await setInGameCurrencyAction(currency);
    setPending(false);

    if (errors.length) return;
    setInGameCurrency(currency);
  };

  return {
    isPending,
    options,
    selectedCurrency: inGameCurrency,
    handleSelect,
  };
};

export default useInGameCurrencySelect;
